import { mount, hydrate, tick } from 'svelte'
import Splide from '@splidejs/splide'
import '@splidejs/splide/css/core'
import './news.scss'

// import NewsSlider from './NewsSlider.svelte'

interface SFNewsItem {
  Id: string
  LastModified: string
  PublicationDate: string
  "Title": string
  "Description": string
  "DateCreated": string
  IncludeInSitemap: boolean
  SystemSourceKey: null|string
  UrlName: string|URL
  ItemDefaultUrl: string|URL
  Order: null|number
  AllowComments: boolean
  Summary: string
  Content: string
  Author: string
  SourceName: string
  SourceSite: string
  Provider: string
}

interface AEMNewsItem {
  Title: string;
  Link: string;
  Description: string;
  PubDate: Date;
  strPubDate: string;
  ID: number;
  Enclosure: string;
  NewsStories: number;
  ToggleImages: boolean;
  ContentTitle: string;
  TxtContent: string;
  IconClass: string;
}

const newsSliderDOM = document.getElementById('com-news-slider')
const splideOptions = {
  type: 'loop',
  autoplay: true,
  gap: '1rem',
  perPage:3,
  perMove:3,
  pagination: true,
  breakpoints: {
    [480]: {
      perPage:1,
      perMove:1,
    },
    [991]: {
      perPage:2,
      perMove:2,
    },
  }
}

let currentPageDOM

const playPauseHandler = (e)=> {
  if(window.getComputedStyle(playDOM).display === 'none') {
    isPaused = false
  } else {
    isPaused = true
  }
}

const paginationMountedHandler = (e)=> {
  const buttons = e.list.querySelectorAll('button')
  // You can add your class to the UL element
  // data.list.classList.add( 'uc-slider-pages' )

  buttons.forEach((_)=> {
    // _.textContent = String( _.page + 1 ) // aria-label takes care of this
    const span = document.createElement('span')
    span.className = 'progress-indicator'
    _.appendChild(span)
  })
}

const tickHandler = (e)=> {
  if(currentPageDOM) currentPageDOM.style.width = `${(e * 100).toFixed(0) || 0}%`
}

const paginationUpdateHandler = (e)=> {
  currentPageDOM = e.list.querySelector('.is-active').firstChild
}

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  const { worker } = await import('../../../../local-dev/mocks/msw-browser.js')
 
  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start()
}

/**
 * This is the place to put code that needs the Mock Service Worker to be running when doing local dev. Outside of development environments, this will be a no-op.
 * 
 * MSW is all about intercepting network requests and returning mocked data, so if you're working on a feature that needs to make a network request, you can provide a simulated payload,
 * and not ding the server on every refresh. This is, of course, great for slower endpoints, and to work around CORS security.
 * 
 * To intercept a request, you need to define a route and provide a response handler. This is done in the `local-dev/mocks/msq-handlers.js` file.
 */
enableMocking().then(async () => {
  if(newsSliderDOM) {
    window.newsSlider = new Splide(newsSliderDOM, splideOptions)
      .on('pagination:mounted', paginationMountedHandler)
      .on('pagination:updated', paginationUpdateHandler)
      .on('autoplay:playing', tickHandler)
      .mount()

      /*
      const newsSlides = newsSlider.Components.Slides.get()
      const datesManifest = newsSliderDOM.dataset.dates?.split(' ').map((_)=> new Date(_))

      const dates = newsSlides.map((_)=> new Date(_.slide.dataset.date))
      const cmsNewsRes = await fetch('/api/default/newsitems?$orderby=PublicationDate desc&$top=10')
      const cmsNews = await cmsNewsRes.json()

      let referenceDateIndex: number = 0

      cmsNews.value.forEach((_: SFNewsItem, i: number)=> {
        // convert the item into DOM that can be added to the slider
        const extractedImgTag = _.Content.match(/<img[^>]+src="([^">]+)"/) || undefined
        const wrappedImg = extractedImgTag ? `
          <div class="img-wrapper">
            ${extractedImgTag}
          </div>
          ` : ``

        const itemDate = new Date(_.DateCreated)

        let description: string = _.Description
        if(description.length < 1) {
          description = _.Content.replace(/(<([^>]+)>)/gi, "")
        }

        const newItem = `
          <li class="splide__slide${ extractedImgTag ? ' has-image' : ''}" data-date="${itemDate}">
            <a class="news-item-link" href="${_.ItemDefaultUrl}">
              <article class="news-card-container">
                  ${wrappedImg}
                <h2 class="caption">
                  <span>
                    ${_.Title.replace('&nbsp;',' ')}
                  </span>
                </h2>
              </article>
            </a>
          </li>
        `

        // @TODO add 

        // compare dates on cmsNews objects to dates in datesManifest to determine positions for inserting into the slider
        if(itemDate >= datesManifest[referenceDateIndex]) {
          // insert _ before this position in the slider
          newsSlider.add(newItem, referenceDateIndex)
        } else {
          // insert _ after/at this position in the slider
        }
      })

      console.log({
        state: newsSlider.state,
        newsSlider,
        newsSlides,
        dates,
        datesManifest,
        cmsNews,
      })
        */
  }

  // if(newsSliderDOM) {
  //   hydrate(NewsSlider, {
  //     target: newsSliderDOM,
  //     props: {
  //       comNewsBaseUrl: 'https://med.uc.edu',
  //       mainCampusBaseUrl: 'https://www.uc.edu',
  //     }
  //   })
  // }
})